import { defineMessages } from 'react-intl';

export default defineMessages({
    accountEmail: {
        id: '_.your_company.account_details.account_email',
        defaultMessage: 'Account Email'
    },
    setNewPassword: {
        id: '_.your_company.account_details.set_new_password',
        defaultMessage: 'Send a link to reset your password'
    },
    resetPasswordCTA: {
        id: '_.your_company.account_details.reset_password_cta',
        defaultMessage: 'Reset password'
    },
    successSentResetPassword: {
        id: '_.your_company.account_details.reset_password_success',
        defaultMessage: "Check your email inbox; we've sent a link"
    },
    failureResetPassword: {
        id: '_.your_company.account_details.reset_password_failure',
        defaultMessage: "Sorry, something's gone wrong. Try again later?"
    },
    changeEmailInfo: {
        id: '_.your_company.account_details.change_email_info',
        defaultMessage:
            'Want to change the email address on your account?\nGive us a ring on \'<a href="tel:020 3397 3375">020 3397 3375</a>\' and we’ll sort it.'
    }
});
